import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { NotifyService } from '@/helpers'
import { CreateStation } from '@/types/station'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function createSite(payload: CreateStation): Promise<void> {
  await stationDataConfigApi.create(payload)
}

function useAddStation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateStation) => createSite(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.stations])
      NotifyService.success(t('AddStationSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      NotifyService.error(error)
    },
  })
}

export default useAddStation
